/* eslint-disable no-undef */
import Web3, { net } from 'web3';
import presaleAbi from './abi/presaleAbi.json';
import erc20Abi from './abi/erc20Abi.json';
import web3config from './web3config';
import { getActiveChains } from '../Action/action';

const validateProvider = async (walletProvider, networkId) => {
  try {
    const chainData = await getActiveChains();
    console.log('Chain Data:', chainData);

    walletProvider = await walletProvider;
    if (!walletProvider) {
      console.log('Wallet provider not found.');
      return {
        status: false,
        message: 'Please connect your web3 wallet',
      };
    }

    const web3 = new Web3(walletProvider);
    const accounts = await walletProvider.request({
      method: 'eth_requestAccounts',
    });

    if (!accounts || accounts.length === 0) {
      return {
        status: false,
        message: 'No accounts found. Please connect your wallet.',
      };
    }

    const currentChainId = await web3.eth.getChainId();
    console.log(
      'Connected Accounts:',
      accounts,
      'Current Chain ID:',
      currentChainId
    );

    const networks = chainData.data.map((data) => ({
      chainId: data.chainNetworkId,
      chainName: data.chainName,
      nativeCurrency: {
        name: data.chainName,
        symbol: data.chainSymbol,
        decimals: 18,
      },
      rpcUrls: [data.chainRPCUrl],
      blockExplorerUrls: [data.chainExplorerUrl],
    }));

    if (networkId !== web3.utils.toHex(currentChainId)) {
      try {
        await walletProvider.request({
          method: 'wallet_switchEthereumChain',
          params: [{ chainId: networkId }],
        });
      } catch (switchError) {
        if (switchError.code === 4902 || switchError.code === 32603) {
          const networkToAdd = networks.find(
            (net) => net.chainId === networkId
          );
          //console.log('neeettttttt',networkToAdd)

          if (networkToAdd) {
            try {
              await walletProvider.request({
                method: 'wallet_addEthereumChain',
                params: [networkToAdd],
              });
            } catch (addError) {
              console.error(`Failed to add network:`, addError);
              return {
                status: false,
                message: `Failed to add the network. Please try again.`,
              };
            }
          } else {
            console.error('Unsupported network:', networkId);
            return {
              status: false,
              message: 'Unsupported network. Please use a supported network.',
            };
          }
        } else {
          console.error('Switch Error:', switchError);
          return {
            status: false,
            message: `Switch Error: ${switchError.message || switchError}`,
          };
        }
      }
    }

    return {
      status: true,
      web3,
      accounts,
      chain: currentChainId,
    };
  } catch (error) {
    console.error('Error in validateProvider:', error);
    return {
      status: false,
      message: 'Error in validating provider. Please try again.',
    };
  }
};

export const TokenSupply = async (req) => {
  try {
    const { walletProvider, tokenAddress, networkId } = req;
    const validate = await validateProvider(walletProvider, networkId);
    if (!validate.status) {
      console.log('Error in provider', validate);
      return validate;
    }
    let web3 = validate.web3;
    let walletAddress = validate.accounts[0];
    let erc20Contract = new web3.eth.Contract(erc20Abi, tokenAddress);
    let decimals = await erc20Contract.methods.decimals().call();
    let total = erc20Contract.methods.totalSupply().call();
    let symbol = erc20Contract.methods.symbol().call();

    return {
      status: true,
      supply: await total,
      symbol: await symbol,
    };
  } catch (error) {
    return {
      status: false,
      message: error.toString(),
    };
  }
};

export const NewSale = async (req) => {
  try {
    let {
      walletProvider,
      preSaleAddress,
      usdtAddress,
      UsdtPrice,
      tokenAddress,
      tokenAmount,
      duration,
      startDateAndTime,
      networkId,
    } = req;
    const validate = await validateProvider(walletProvider, networkId);
    if (!validate.status) {
      console.log('Error in provider', validate);
      return validate;
    }
    let web3 = await validate.web3;
    let walletAddress = await validate.accounts[0];
    let contractPresale = new web3.eth.Contract(presaleAbi, preSaleAddress);
    let erc20Contract = new web3.eth.Contract(erc20Abi, usdtAddress);
    let decimals = await erc20Contract.methods.decimals().call();

    let tokenContract = new web3.eth.Contract(erc20Abi, tokenAddress);
    let tokenDecimals = await tokenContract.methods.decimals().call();

    let priceUsdt = parseInt(
      UsdtPrice * 10 ** parseInt(decimals)
    ).toLocaleString('fullwide', { useGrouping: false });
    let amount = (tokenAmount * 10 ** parseInt(tokenDecimals)).toLocaleString(
      'fullwide',
      { useGrouping: false }
    );

    let durationInSeconds = Math.floor(duration * 86400);
    const startDateInSeconds = Math.floor(
      new Date(startDateAndTime).getTime() / 1000
    );
    let endTime = startDateInSeconds + durationInSeconds;
    //console.log('DUUU',durationInSeconds,startDateInSeconds,endTime)
    let isBlacklisted = await contractPresale.methods
      .isBlacklisted(walletAddress)
      .call();
    if (isBlacklisted) {
      return {
        //status: true,
        message: 'Address blacklisted. Contact admin',
      };
    }

    let doesExist = await contractPresale.methods
      .doesSaleExist(tokenAddress)
      .call();
    // console.log('STA',doesExist,tokenAddress,!doesExist)
    if (doesExist) {
      return {
        //status: true,
        message: 'Sale already exists for this token',
      };
    }

    let trx = await contractPresale.methods.createPreSale(
      tokenAddress,
      amount,
      priceUsdt,
      endTime
    );
    //console.log('tRXXX',amount,priceUsdt)

    let gasPrice = await web3.eth.getGasPrice();
    let gasLimit = await web3.eth.estimateGas({
      gasPrice: web3.utils.toHex(gasPrice),
      to: preSaleAddress,
      from: walletAddress,
      data: trx.encodeABI(),
    });

    const trxData = await web3.eth.sendTransaction({
      gasPrice: web3.utils.toHex(gasPrice),
      gas: web3.utils.toHex(gasLimit),
      to: preSaleAddress,
      from: walletAddress,
      data: trx.encodeABI(),
    });

    return {
      status: true,
      hash: trxData.transactionHash,
      message:
        'Success. It will take a few minutes to confirm the transaction on chain.',
    };
  } catch (error) {
    if (error && error.data) {
      console.log('ERRR', error.data);
    }
    return {
      status: false,
      message: error.toString(),
    };
  }
};

export const ApproveUsdtToken = async (req) => {
  try {
    const {
      walletProvider,
      usdtAddress,
      preSaleAddress,
      networkId,
      buyAmount,
    } = req;
    const validate = await validateProvider(walletProvider, networkId);
    if (!validate.status) {
      return validate;
    }
    let web3 = validate.web3;
    let walletAddress = validate.accounts[0];
    let erc20Contract = new web3.eth.Contract(erc20Abi, usdtAddress);
    let decimals = await erc20Contract.methods.decimals().call();
    const allowance = await erc20Contract.methods
      .allowance(walletAddress, preSaleAddress)
      .call();
    const amount = BigInt(
      Math.floor(parseFloat(buyAmount) * 10 ** parseInt(decimals))
    );

    if (BigInt(allowance) >= amount) {
      return {
        status: true,
        alreadyApproved: true,
      };
    }
    let trx = erc20Contract.methods.approve(
      preSaleAddress,
      '0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff'
    );
    let gasPrice = await web3.eth.getGasPrice();
    let gasLimit = await web3.eth.estimateGas({ from: walletAddress });
    const trxData = await web3.eth.sendTransaction({
      from: walletAddress,
      to: usdtAddress,
      gas: web3.utils.toHex(gasLimit),
      gasPrice: web3.utils.toHex(gasPrice),
      data: trx.encodeABI(),
    });
    return {
      status: true,
      alreadyApproved: false,
      hash: trxData.transactionHash,
    };
  } catch (error) {
    return {
      status: false,
      message: error.toString(),
    };
  }
};

export const ApproveToken = async (req) => {
  try {
    const {
      walletProvider,
      tokenAddress,
      preSaleAddress,
      tokenAmount,
      networkId,
    } = req;

    const validate = await validateProvider(walletProvider, networkId);
    if (!validate.status) {
      console.log('Error in provider', validate);
      return validate;
    }
    let web3 = validate.web3;
    let walletAddress = validate.accounts[0];

    let erc20Contract = new web3.eth.Contract(erc20Abi, tokenAddress);
    const allowance = await erc20Contract.methods
      .allowance(walletAddress, preSaleAddress)
      .call();
    let decimals = await erc20Contract.methods.decimals().call();
    const amount = BigInt(
      Math.floor(parseFloat(tokenAmount) * 10 ** parseInt(decimals))
    );
    if (BigInt(allowance) >= amount) {
      return {
        status: true,
        alreadyApproved: true,
      };
    }
    let trx = erc20Contract.methods.approve(
      preSaleAddress,
      '0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff'
    );

    let gasPrice = await web3.eth.getGasPrice();
    let gasLimit = await web3.eth.estimateGas({ from: walletAddress });
    const trxData = await web3.eth.sendTransaction({
      from: walletAddress,
      to: tokenAddress,
      gas: web3.utils.toHex(gasLimit),
      gasPrice: web3.utils.toHex(gasPrice),
      data: trx.encodeABI(),
    });

    return {
      status: true,
      alreadyApproved: false,
      hash: trxData.transactionHash,
    };
  } catch (error) {
    return {
      status: false,
      message: error.toString(),
    };
  }
};

export const BuyTokenUsdt = async (req) => {
  try {
    const {
      walletProvider,
      usdtAddress,
      preSaleAddress,
      buyAmount,
      tokenAddress,
      networkId,
    } = req;
    const validate = await validateProvider(walletProvider, networkId);
    if (!validate.status) {
      return validate;
    }
    let web3 = validate.web3;
    let walletAddress = validate.accounts[0];
    let contractPresale = new web3.eth.Contract(presaleAbi, preSaleAddress);
    let erc20Contract = new web3.eth.Contract(erc20Abi, usdtAddress);
    let decimals = await erc20Contract.methods.decimals().call();

    let amount = (buyAmount * 10 ** parseInt(decimals)).toLocaleString(
      'fullwide',
      {
        useGrouping: false,
      }
    );

    let isPresaleActive = await contractPresale.methods
      .isPresaleActive(tokenAddress)
      .call();
    if (!isPresaleActive) {
      return {
        status: false,
        message: 'Token buying not started',
      };
    }

    let trx = await contractPresale.methods.buyTokenWithUSDT(
      tokenAddress,
      amount
    );

    let gasPrice = await web3.eth.getGasPrice();
    let gasLimit = await web3.eth.estimateGas({
      gasPrice: web3.utils.toHex(gasPrice),
      to: preSaleAddress,
      from: walletAddress,
      data: trx.encodeABI(),
    });

    const trxData = await web3.eth.sendTransaction({
      gasPrice: web3.utils.toHex(gasPrice),
      gas: web3.utils.toHex(gasLimit),
      to: preSaleAddress,
      from: walletAddress,
      data: trx.encodeABI(),
    });

    return {
      status: true,
      hash: trxData.transactionHash,
      message:
        'Token bought successfully.Come back here to claim your tokens after presale is over',
    };
  } catch (error) {
    return {
      status: false,
      message: error.toString(),
    };
  }
};

export const ClaimToken = async (req) => {
  try {
    const { walletProvider, preSaleAddress, tokenAddress, networkId } = req;
    const validate = await validateProvider(walletProvider, networkId);
    if (!validate.status) {
      return validate;
    }
    let web3 = validate.web3;
    let walletAddress = validate.accounts[0];
    let contractPresale = new web3.eth.Contract(presaleAbi, preSaleAddress);
    let erc20Contract = new web3.eth.Contract(erc20Abi, tokenAddress);
    let decimals = await erc20Contract.methods.decimals().call();
    //console.log({decimals})

    let isClaimed = await contractPresale.methods
      .claimStatus(tokenAddress)
      .call();
    if (isClaimed) {
      return {
        message: 'Already claimed',
      };
    }

    let trx = await contractPresale.methods.claimTokens(tokenAddress);

    let gasPrice = await web3.eth.getGasPrice();
    let gasLimit = await web3.eth.estimateGas({
      gasPrice: web3.utils.toHex(gasPrice),
      to: preSaleAddress,
      from: walletAddress,
      data: trx.encodeABI(),
    });

    const trxData = await web3.eth.sendTransaction({
      gasPrice: web3.utils.toHex(gasPrice),
      gas: web3.utils.toHex(gasLimit),
      to: preSaleAddress,
      from: walletAddress,
      data: trx.encodeABI(),
    });

    return {
      status: true,
      hash: trxData.transactionHash,
      message:
        'Token claimed successfully. It will take a few minutes to confirm the transaction.Please check your wallet after some time',
    };
  } catch (error) {
    console.log('CLAIM', error);
    return {
      status: false,
      message: error.toString(),
    };
  }
};

export const ClaimTokenStatus = async (req) => {
  try {
    const { walletProvider, preSaleAddress, tokenAddress, networkId } = req;
    const validate = await validateProvider(walletProvider, networkId);
    if (!validate.status) {
      return validate;
    }
    let web3 = validate.web3;
    let walletAddress = validate.accounts[0];
    let contractPresale = new web3.eth.Contract(presaleAbi, preSaleAddress);
    let erc20Contract = new web3.eth.Contract(erc20Abi, tokenAddress);

    let isClaimed = await contractPresale.methods
      .claimStatus(tokenAddress)
      .call({ from: walletAddress });
    return {
      status: isClaimed,
      message: 'Already claimed',
    };
  } catch (error) {
    console.log('CLAIM', error);
    return {
      status: false,
      message: error.toString(),
    };
  }
};

export const RefundTokens = async (req) => {
  try {
    const { walletProvider, preSaleAddress, tokenAddress, networkId } = req;
    const validate = await validateProvider(walletProvider, networkId);
    if (!validate.status) {
      return validate;
    }
    let web3 = validate.web3;
    let walletAddress = validate.accounts[0];

    let contractPresale = new web3.eth.Contract(presaleAbi, preSaleAddress);
    let erc20Contract = new web3.eth.Contract(erc20Abi, tokenAddress);
    let decimals = await erc20Contract.methods.decimals().call();

    let isRefunded = await contractPresale.methods
      .refundStatus(tokenAddress)
      .call();
    if (isRefunded) {
      return {
        message: 'Already refunded',
      };
    }

    let trx = await contractPresale.methods.refund(tokenAddress);

    let gasPrice = await web3.eth.getGasPrice();
    let gasLimit = await web3.eth.estimateGas({
      gasPrice: web3.utils.toHex(gasPrice),
      to: preSaleAddress,
      from: walletAddress,
      data: trx.encodeABI(),
    });

    const trxData = await web3.eth.sendTransaction({
      gasPrice: web3.utils.toHex(gasPrice),
      gas: web3.utils.toHex(gasLimit),
      to: preSaleAddress,
      from: walletAddress,
      data: trx.encodeABI(),
    });

    return {
      status: true,
      hash: trxData.transactionHash,
      message:
        'USDT refunded successfully. It will take a few minutes to confirm the transaction. Please check your wallet after sometime',
    };
  } catch (error) {
    console.log('REFUND', error);
    return {
      status: false,
      message: error.toString(),
    };
  }
};

export const WithdrawTokens = async (req) => {
  try {
    const { walletProvider, preSaleAddress, tokenAddress, networkId } = req;
    const validate = await validateProvider(walletProvider, networkId);
    if (!validate.status) {
      return validate;
    }
    let web3 = validate.web3;
    let walletAddress = validate.accounts[0];
    let contractPresale = new web3.eth.Contract(presaleAbi, preSaleAddress);
    let erc20Contract = new web3.eth.Contract(erc20Abi, tokenAddress);
    let decimals = await erc20Contract.methods.decimals().call();

    let trx = await contractPresale.methods.withdrawTokensUser(tokenAddress);

    let gasPrice = await web3.eth.getGasPrice();
    let gasLimit = await web3.eth.estimateGas({
      gasPrice: web3.utils.toHex(gasPrice),
      to: preSaleAddress,
      from: walletAddress,
      data: trx.encodeABI(),
    });

    const trxData = await web3.eth.sendTransaction({
      gasPrice: web3.utils.toHex(gasPrice),
      gas: web3.utils.toHex(gasLimit),
      to: preSaleAddress,
      from: walletAddress,
      data: trx.encodeABI(),
    });

    return {
      status: true,
      hash: trxData.transactionHash,
      message:
        'Tokens withdrawn successfully. It will take a few minutes to confirm the transaction. Please check your wallet after sometime',
    };
  } catch (error) {
    console.log('withdraw', error);
    return {
      status: false,
      message: error.toString(),
    };
  }
};

export const PreSaleData = async (req) => {
  try {
    const { walletProvider, preSaleAddress, tokenAddress, networkId } = req;
    const validate = await validateProvider(walletProvider, networkId);
    if (!validate.status) {
      return validate;
    }
    let web3 = validate.web3;
    let walletAddress = await validate.accounts[0];
    let contractPresale = new web3.eth.Contract(presaleAbi, preSaleAddress);

    let result = await contractPresale.methods
      .getPreSaleDetails(tokenAddress)
      .call();
    //console.log('1234',result)
    return {
      staus: true,
      Available: Number(result.tokensAvailableForSale) / 10 ** 18,
      Sold: Number(result.tokensSold) / 10 ** 18,
    };
  } catch (error) {
    return {
      status: false,
      message: error.toString(),
    };
  }
};

export const TokenPriceUsdt = async (req) => {
  try {
    let data = req;
    let results = [];
    for (let i = 0; i < data.length; i++) {
      const validate = await validateProvider2(data[i].chainRPCUrl);
      if (!validate.status) {
        return validate;
      }
      let web3 = validate.web3;
      let presaleContract = new web3.eth.Contract(
        presaleAbi,
        data[i].presaleContract
      );
      let contractUsdt = new web3.eth.Contract(erc20Abi, data[i].usdtContract);
      let decimals = await contractUsdt.methods.decimals().call();
      let trx = await presaleContract.methods
        .getTokenPriceInUsdt(data[i].token_address)
        .call();
      // console.log('POX',data[i].presaleContract,data[i].usdtContract, data[i].token_address)
      let Price =
        Number(trx) /
        10 **
          parseInt(decimals).toLocaleString('fullwide', { useGrouping: false });
      results.push(Price);
    }
    return {
      status: true,
      data: results,
    };
  } catch (error) {
    console.error('Error getting token price', error);
  }
};

export const getTokenSupplyPresale = async (req) => {
  try {
    let data = req;
    let results = [];
    for (let i = 0; i < data.length; i++) {
      const validate = await validateProvider2(data[i].chainRPCUrl);
      if (!validate.status) {
        return validate;
      }
      let web3 = validate.web3;
      let contractToken = new web3.eth.Contract(
        erc20Abi,
        data[i].token_address
      );
      let decimals = await contractToken.methods.decimals().call();
      let trx = await contractToken.methods
        .totalSupply(data[i].token_address)
        .call();
      //console.log('LOO',trx)
      let Supply =
        Number(trx) /
        10 **
          parseInt(decimals).toLocaleString('fullwide', { useGrouping: false });
      results.push(Supply);
    }
    return {
      status: true,
      data: results,
    };
  } catch (error) {
    console.error('Error getting token price', error);
  }
};

export const PresaleTokenSupply = async (req) => {
  try {
    let data = req;
    let results = [];
    for (let i = 0; i < data.length; i++) {
      const validate = await validateProvider2(data[i].chainRPCUrl);
      if (!validate.status) {
        return validate;
      }
      let web3 = validate.web3;
      let contractToken = new web3.eth.Contract(
        erc20Abi,
        data[i].token_address
      );
      let decimals = await contractToken.methods.decimals().call();
      let trx = await contractToken.methods
        .totalSupply(data[i].token_address)
        .call();
      //console.log('LOO',trx)
      let Supply =
        Number(trx) /
        10 **
          parseInt(decimals).toLocaleString('fullwide', { useGrouping: false });
      results.push(Supply);
    }
    return {
      status: true,
      data: results,
    };
  } catch (error) {
    console.error('Error getting token price', error);
  }
};

export const TokenSaleDuration = async (req) => {
  try {
    let data = req;
    let currentTime = Math.floor(Date.now() / 1000);
    let results = [];
    for (let i = 0; i < data.length; i++) {
      const validate = await validateProvider2(data[i].chainRPCUrl);
      if (!validate.status) {
        return validate;
      }
      let web3 = validate.web3;
      let contractPresale = new web3.eth.Contract(
        presaleAbi,
        data[i].presaleContract
      );

      let trx = await contractPresale.methods
        .getPresaleDuration(data[i].token_address)
        .call();
      const isPre = currentTime > trx;
      results.push(isPre);
      //console.log('ADD',results)
    }
    return {
      status: true,
      duration: results,
    };
  } catch (error) {
    return {
      status: false,
      message: error.toString(),
    };
  }
};

export const TokenSaleDuration2 = async (req) => {
  try {
    let currentTime = Math.floor(Date.now() / 1000);
    const { walletProvider, preSaleAddress, tokenAddress, networkId } = req;
    const validate = await validateProvider(walletProvider, networkId);
    if (!validate.status) {
      return validate;
    }
    let web3 = validate.web3;
    let walletAddress = validate.accounts[0];
    let contractPresale = new web3.eth.Contract(presaleAbi, preSaleAddress);

    let trx = await contractPresale.methods
      .getPresaleDuration(tokenAddress)
      .call();
    console.log('time2', currentTime, trx);
    const isPre = currentTime > trx;
    return {
      status: true,
      duration: isPre,
      time: trx,
    };
  } catch (error) {
    return {
      status: false,
      message: error.toString(),
    };
  }
};

export const StartSale = async (req) => {
  try {
    const { walletProvider, preSaleAddress, tokenAddress, networkId } = req;
    const validate = await validateProvider(walletProvider, networkId);
    if (!validate.status) {
      return validate;
    }
    let web3 = validate.web3;
    let walletAddress = validate.accounts[0];
    let contractPresale = new web3.eth.Contract(presaleAbi, preSaleAddress);
    let erc20Contract = new web3.eth.Contract(erc20Abi, tokenAddress);

    let isActive = await contractPresale.methods
      .isPresaleActive(tokenAddress)
      .call();
    if (isActive) {
      return {
        //status: true,
        message: 'Sale already active',
      };
    }

    let trx = await contractPresale.methods.startPreSale(tokenAddress);

    let gasPrice = await web3.eth.getGasPrice();
    let gasLimit = await web3.eth.estimateGas({
      gasPrice: web3.utils.toHex(gasPrice),
      to: preSaleAddress,
      from: walletAddress,
      data: trx.encodeABI(),
    });

    const trxData = await web3.eth.sendTransaction({
      gasPrice: web3.utils.toHex(gasPrice),
      gas: web3.utils.toHex(gasLimit),
      to: preSaleAddress,
      from: walletAddress,
      data: trx.encodeABI(),
    });

    return {
      status: true,
      hash: trxData.transactionHash,
    };
  } catch (error) {
    return {
      status: false,
      message: error.toString(),
    };
  }
};

export const StopSale = async (req) => {
  try {
    const { walletProvider, preSaleAddress, tokenAddress, networkId } = req;
    const validate = await validateProvider(walletProvider, networkId);
    if (!validate.status) {
      return validate;
    }
    let web3 = validate.web3;
    let walletAddress = validate.accounts[0];
    let contractPresale = new web3.eth.Contract(presaleAbi, preSaleAddress);
    let erc20Contract = new web3.eth.Contract(erc20Abi, tokenAddress);

    let isActive = await contractPresale.methods
      .isPresaleActive(tokenAddress)
      .call();
    if (!isActive) {
      return {
        //status: true,
        message: 'Sale not active',
      };
    }

    let trx = await contractPresale.methods.stopPreSale(tokenAddress);

    let gasPrice = await web3.eth.getGasPrice();
    let gasLimit = await web3.eth.estimateGas({
      gasPrice: web3.utils.toHex(gasPrice),
      to: preSaleAddress,
      from: walletAddress,
      data: trx.encodeABI(),
    });

    const trxData = await web3.eth.sendTransaction({
      gasPrice: web3.utils.toHex(gasPrice),
      gas: web3.utils.toHex(gasLimit),
      to: preSaleAddress,
      from: walletAddress,
      data: trx.encodeABI(),
    });

    return {
      status: true,
      hash: trxData.transactionHash,
    };
  } catch (error) {
    return {
      status: false,
      message: error.toString(),
    };
  }
};

export const UpdateSaleDuration = async (req) => {
  try {
    const {
      walletProvider,
      preSaleAddress,
      tokenAddress,
      networkId,
      duration,
    } = req;
    const validate = await validateProvider(walletProvider, networkId);
    if (!validate.status) {
      return validate;
    }
    let web3 = validate.web3;
    let walletAddress = validate.accounts[0];
    let contractPresale = new web3.eth.Contract(presaleAbi, preSaleAddress);
    let erc20Contract = new web3.eth.Contract(erc20Abi, tokenAddress);
    let currentTime = Math.floor(Date.now() / 1000);
    let newDuration = Math.floor(duration * 86400);
    let updatedDuration = newDuration + currentTime;
    //console.log('new tim',newDuration+currentTime)

    let trx = await contractPresale.methods.updatePresaleDuration(
      tokenAddress,
      updatedDuration
    );

    let gasPrice = await web3.eth.getGasPrice();
    let gasLimit = await web3.eth.estimateGas({
      gasPrice: web3.utils.toHex(gasPrice),
      to: preSaleAddress,
      from: walletAddress,
      data: trx.encodeABI(),
    });

    const trxData = await web3.eth.sendTransaction({
      gasPrice: web3.utils.toHex(gasPrice),
      gas: web3.utils.toHex(gasLimit),
      to: preSaleAddress,
      from: walletAddress,
      data: trx.encodeABI(),
    });

    return {
      status: true,
      hash: trxData.transactionHash,
      message: 'Duration Updated',
    };
  } catch (error) {
    return {
      status: false,
      message: error.data.message.toString(),
    };
  }
};

export const getUsdtBalance = async (req) => {
  try {
    const { walletProvider, usdtAddress, preSaleAddress, networkId } = req;
    const validate = await validateProvider(walletProvider, networkId);
    if (!validate.status) {
      return validate;
    }
    let web3 = validate.web3;
    let walletAddress = await validate.accounts[0];
    let usdtContract = new web3.eth.Contract(erc20Abi, usdtAddress);

    let balance = await usdtContract.methods.balanceOf(walletAddress).call();
    //let contractPresale = new web3.eth.Contract(presaleAbi,preSaleAddress)

    let decimals = await usdtContract.methods.decimals().call();
    let allowance = await usdtContract.methods
      .allowance(walletAddress, preSaleAddress)
      .call();
    console.log({
      walletAddress,
      usdtAddress,
      preSaleAddress,
      walletProvider,
      status: true,
      balance: parseInt(balance) / 10 ** parseInt(decimals),
      allowance: parseInt(allowance) / 10 ** parseInt(decimals),
    });
    return {
      status: true,
      balance: parseInt(balance) / 10 ** parseInt(decimals),
      allowance: parseInt(allowance) / 10 ** parseInt(decimals),
    };
  } catch (error) {
    console.error(error);
  }
};

export const UsdtEarned = async (req) => {
  try {
    const { walletProvider, preSaleAddress, tokenAddress, networkId } = req;
    const validate = await validateProvider(walletProvider, networkId);
    if (!validate.status) {
      return validate;
    }
    let web3 = validate.web3;
    let walletAddress = await validate.accounts[0];
    let contractPresale = new web3.eth.Contract(presaleAbi, preSaleAddress);

    let trx = await contractPresale.methods
      .getTotalUsdtEarned(tokenAddress)
      .call();
    if (networkId == web3config.ChaiIdBinance) {
      return {
        status: true,
        usdtAmount: Number(trx) / 10 ** 18,
      };
    } else {
      return {
        status: true,
        usdtAmount: Number(trx) / 10 ** 6,
      };
    }
  } catch (error) {
    return {
      status: false,
      message: error.toString(),
    };
  }
};

export const TransferUsdt = async (req) => {
  try {
    const {
      walletProvider,
      preSaleAddress,
      tokenAddress,
      usdtAmount,
      usdtAddress,
      networkId,
    } = req;

    const validate = await validateProvider(walletProvider, networkId);
    if (!validate.status) {
      return validate;
    }
    let web3 = validate.web3;
    let walletAddress = validate.accounts[0];
    let contractPresale = new web3.eth.Contract(presaleAbi, preSaleAddress);
    let contractUsdt = new web3.eth.Contract(erc20Abi, usdtAddress);
    let decimals = await contractUsdt.methods.decimals().call();

    let amount = (usdtAmount * 10 ** parseInt(decimals)).toLocaleString(
      'fullwide',
      { useGrouping: false }
    );
    console.log('xx', amount);
    let trx = await contractPresale.methods.sendUsdtToPool(
      tokenAddress,
      amount
    );

    let gasPrice = await web3.eth.getGasPrice();
    let gasLimit = await web3.eth.estimateGas({
      gasPrice: web3.utils.toHex(gasPrice),
      to: preSaleAddress,
      from: walletAddress,
      data: trx.encodeABI(),
    });

    const trxData = await web3.eth.sendTransaction({
      gasPrice: web3.utils.toHex(gasPrice),
      gas: web3.utils.toHex(gasLimit),
      to: preSaleAddress,
      from: walletAddress,
      data: trx.encodeABI(),
    });

    return {
      status: true,
      hash: trxData.transactionHash,
    };
  } catch (error) {
    return {
      status: false,
      message: error.toString(),
    };
  }
};

export const UserToken = async (req) => {
  try {
    const { walletProvider, preSaleAddress, tokenAddress, networkId } = req;
    const validate = await validateProvider(walletProvider, networkId);
    if (!validate.status) {
      console.log('Error in provider', validate);
      return validate;
    }
    let web3 = validate.web3;
    let walletAddress = validate.accounts[0];
    let contractPresale = new web3.eth.Contract(presaleAbi, preSaleAddress);
    let token = await contractPresale.methods
      .getUserToken(tokenAddress)
      .call({ from: walletAddress });

    return {
      status: true,
      tokenAmt: Number(token) / 10 ** 18,
    };
  } catch (error) {
    return {
      status: false,
      message: error.toString(),
    };
  }
};

export const UserUsdt = async (req) => {
  try {
    const { walletProvider, preSaleAddress, tokenAddress, networkId } = req;
    const validate = await validateProvider(walletProvider, networkId);
    if (!validate.status) {
      console.log('Error in provider', validate);
      return validate;
    }
    let web3 = validate.web3;
    let walletAddress = validate.accounts[0];
    let contractPresale = new web3.eth.Contract(presaleAbi, preSaleAddress);
    let usdt = await contractPresale.methods
      .getUserUsdt(tokenAddress)
      .call({ from: walletAddress });
    if (networkId == web3config.ChaiIdBinance) {
      return {
        status: true,
        usdtAmount: Number(usdt) / 10 ** 18,
      };
    } else {
      return {
        status: true,
        usdtAmount: Number(usdt) / 10 ** 6,
      };
    }
  } catch (error) {
    return {
      status: false,
      message: error.toString(),
    };
  }
};

export const RefundStat = async (req) => {
  try {
    const { walletProvider, preSaleAddress, tokenAddress, networkId } = req;
    const validate = await validateProvider(walletProvider, networkId);
    if (!validate.status) {
      return validate;
    }
    let web3 = validate.web3;
    let walletAddress = await validate.accounts[0];
    let contractPresale = new web3.eth.Contract(presaleAbi, preSaleAddress);

    let trx = await contractPresale.methods
      .refundStatus(tokenAddress)
      .call({ from: walletAddress });

    return {
      status: trx,
    };
  } catch (error) {
    return {
      status: false,
      message: error.toString(),
    };
  }
};

export const WithdrawStatus = async (req) => {
  try {
    const { walletProvider, preSaleAddress, tokenAddress, networkId } = req;
    const validate = await validateProvider(walletProvider, networkId);
    if (!validate.status) {
      return validate;
    }
    let web3 = validate.web3;
    let walletAddress = await validate.accounts[0];
    let contractPresale = new web3.eth.Contract(presaleAbi, preSaleAddress);

    let trx = await contractPresale.methods.canWithdraw(tokenAddress).call();

    return {
      status: trx,
    };
  } catch (error) {
    return {
      status: false,
      message: error.toString(),
    };
  }
};

export const WithdrawStatus2 = async (req) => {
  try {
    let data = req;
    let results = [];
    for (let i = 0; i < data.length; i++) {
      const validate = await validateProvider2(data[i].chainRPCUrl);
      if (!validate.status) {
        return validate;
      }
      let web3 = validate.web3;
      let contractPresale = new web3.eth.Contract(
        presaleAbi,
        data[i].presaleContract
      );
      let trx = await contractPresale.methods
        .canWithdraw(data[i].token_address)
        .call();
      results.push(trx);
    }
    return {
      status: true,
      can: results,
    };
  } catch (error) {
    return {
      status: false,
      message: error.toString(),
    };
  }
};

export const SaleStatus = async (req) => {
  try {
    let data = req;
    let results = [];
    for (let i = 0; i < data.length; i++) {
      const validate = await validateProvider2(data[i].chainRPCUrl);
      if (!validate.status) {
        return validate;
      }
      let web3 = validate.web3;
      let contractPresale = new web3.eth.Contract(
        presaleAbi,
        data[i].presaleContract
      );
      let trx = await contractPresale.methods
        .isPresaleActive(data[i].token_address)
        .call();
      results.push(trx);
    }
    return {
      status: true,
      isactive: results,
    };
  } catch (error) {
    return {
      status: false,
      message: error.toString(),
    };
  }
};

const validateProvider2 = async (walletProvider) => {
  // console.log("validateProvider2");
  try {
    if (!walletProvider) {
      //   console.log("walletProvider");

      return {
        status: false,
        message: `Please connect your web3 wallet`,
      };
    }
    const web3 = new Web3(walletProvider);

    return {
      status: true,
      web3,
    };
  } catch (error) {
    console.log('Error in validateProvider :', error);
    return {
      status: false,
      message: 'Error in validating provider. Please try again.',
    };
  }
};
